export default __webpack_public_path__ + "media/header2x.c906d392.png";